import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { client } from "./client.js";
import * as accountsModule from "@/store/modules/Accounts.js";
import * as checkoutModule from "@/store/modules/Checkout.js";
import * as paymentsModule from "@/store/modules/Payments.js";
import * as profileModule from "@/store/modules/Profile.js";

Vue.use(Vuex)

//axios.defaults.baseURL = 'http://deser.core/api'
//axios.defaults.baseURL = 'http://localhost:8000/api'
const store =  new Vuex.Store({
  modules: {
    accountsModule,
    checkoutModule,
    paymentsModule,
    profileModule
  },

  mutations: {
    
  },

  actions: {
    
  },

  getters : {
  }
})
export default store